export default {
  basicRequestInformation: {
    segmento: '',
    estrato: '',
    tipoVivienda: '',
    claseVivienda: '',
    posicionHogar: '',
    nivelEscolaridad: '',
    simulation: {
      cliente: {
        nombres: '',
        identificacion: '',
        tipoIdentificacion: '',
      }
    },
    adoSegmentCode: ''
  },
  financeInformationOne: {
    
  },
  financeInformationTwo: {
    fechaDesembolso1: '1998/09/09'
  },
  centralInformation: {
    tipoDocumento: '',
    archive: [],
    cuotasHipotecarias: 0,
    financialCommitments: {
      creditosHipotecarios: [],
      creditosRotativos: [],
      tarjetasCredito: [],
      cuotasHipotecarias: 0,
      otrasCuotasFinancieras: 0,
    }
  },
  otherCertifiedIncome: {
    ingresosAdicionalesCertificados: 0,
    archive: []
  }
}
